var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientContactUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7504 8.55537C15.7504 8.20937 15.7504 8.03637 15.8024 7.88237C15.9534 7.43437 16.3524 7.26137 16.7524 7.07937C17.2004 6.87437 17.4244 6.77237 17.6474 6.75437C17.8994 6.73437 18.1524 6.78837 18.3684 6.90937C18.6544 7.06937 18.8544 7.37537 19.0584 7.62337C20.0014 8.76937 20.4734 9.34237 20.6454 9.97337C20.7854 10.4834 20.7854 11.0174 20.6454 11.5264C20.3944 12.4484 19.5994 13.2204 19.0104 13.9364C18.7094 14.3014 18.5584 14.4844 18.3684 14.5914C18.1487 14.7132 17.8978 14.7672 17.6474 14.7464C17.4244 14.7284 17.2004 14.6264 16.7514 14.4214C16.3514 14.2394 15.9534 14.0664 15.8024 13.6184C15.7504 13.4644 15.7504 13.2914 15.7504 12.9454V8.55537ZM5.7504 8.55537C5.7504 8.11937 5.7384 7.72837 5.3864 7.42237C5.2584 7.31137 5.0884 7.23437 4.7494 7.07937C4.3004 6.87537 4.0764 6.77237 3.8534 6.75437C3.1864 6.70037 2.8274 7.15637 2.4434 7.62437C1.4994 8.76937 1.0274 9.34237 0.854396 9.97437C0.715201 10.4827 0.715201 11.0191 0.854396 11.5274C1.1064 12.4484 1.9024 13.2214 2.4904 13.9364C2.8614 14.3864 3.2164 14.7974 3.8534 14.7464C4.0764 14.7284 4.3004 14.6264 4.7494 14.4214C5.0894 14.2674 5.2584 14.1894 5.3864 14.0784C5.7384 13.7724 5.7504 13.3814 5.7504 12.9464V8.55537Z",
    stroke: "#777777",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75C3.75 3.436 6.884 0.75 10.75 0.75C14.616 0.75 17.75 3.436 17.75 6.75",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14.75V15.55C17.75 17.317 15.96 18.75 13.75 18.75H11.75",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientContactUs);
export default __webpack_public_path__ + "static/media/ClientContactUs.b6c82017bcf95826e5a945bd99e05de4.svg";
export { ForwardRef as ReactComponent };